export default "__VITE_ASSET__C1d$Fobh__"